import { type FC, useCallback } from 'react';

import { useListingByPinContext } from '@/microfrontends/listing/shared/context/ListingByPinContext';

import { boundActionsFactory } from '@/packages/redux-state/store';
import { useActivePinPageSelector } from '@/packages/redux-state/store/slices/mapControls';
import { extractUndefined } from '@/packages/utils';

import { type PaginationItem } from '../types/pagination';

import { PaginationContainer } from './PaginationContainer';

const useBoundActions = boundActionsFactory(reduxActions => ({
  setActivePinPage: reduxActions.mapControls.setActivePinPage,
}));

export const ListingByPinPaginationContainer: FC = () => {
  const {
    listingProperties: { offersPerPage, totalOffers, maxPage },
  } = useListingByPinContext();

  const boundActions = useBoundActions();

  const activePinPage = useActivePinPageSelector();

  const handlePageClick = useCallback<(paginationItem: PaginationItem) => void>(
    paginationItem => boundActions.setActivePinPage(paginationItem.page),
    [boundActions],
  );

  return (
    <PaginationContainer
      maxPage={extractUndefined(maxPage)}
      offersPerPage={offersPerPage}
      page={activePinPage ?? 1}
      totalOffers={totalOffers}
      onPageClick={handlePageClick}
    />
  );
};
